import React from "react";
import { FileText, Wine, MessageCircle, UtensilsCrossed } from "lucide-react";

const POINTS: [React.ElementType, string, string][] = [
  [FileText, "A sheet for every bottle", "Vintage, region, grapes, producer and what it tastes like — printed and tucked into the case."],
  [UtensilsCrossed, "What food to pair it with", "A food pairing on every sheet — simple ideas for the table, from a weeknight supper to Sunday lunch."],
  [Wine, "When to open it", "Drink-now or lay-down guidance, so nothing is opened too soon or forgotten."],
  [MessageCircle, "Ask about any of them", "We're a message away if a wine surprises you — and every note lives in your Cellar Book."],
];

export function TastingNotesPerk({ tone = "var(--club-dark)", eyebrow = "Included with every case", compact = false }: { tone?: string; eyebrow?: string; compact?: boolean }) {
  return (
    <section className={`grid gap-8 border border-border bg-white ${compact ? "p-6 lg:grid-cols-12 lg:p-8" : "p-6 lg:grid-cols-12 lg:p-12"}`} data-testid="tasting-notes-perk">
      <div className="lg:col-span-6">
        <img src="/brand/club/tasting-notes-fan.png" alt="A fan of Pierre Hourlier Wines tasting-note sheets" className="h-auto w-full max-h-none object-contain object-top" loading="lazy" data-testid="tasting-notes-fan" />
      </div>
      <div className="flex flex-col justify-center lg:col-span-6">
        <div className="eyebrow" style={{ color: tone }}>{eyebrow}</div>
        <h2 className="mt-3 font-serif text-3xl leading-tight sm:text-4xl">Our tasting notes, with every wine</h2>
        <ul className="mt-6 space-y-4">
          {POINTS.map(([Icon, title, body]) => <li key={title} className="flex gap-3"><span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center border border-border"><Icon className="h-4 w-4" strokeWidth={1.5} style={{ color: tone }} /></span><div><div className="font-brand text-[12px] font-bold uppercase tracking-[0.12em]">{title}</div><p className="mt-1 text-sm text-neutral-600">{body}</p></div></li>)}
        </ul>
      </div>
    </section>
  );
}
